import * as action from './actions';

export const getVendorEntertainment = (vendorId) => {
  return {
    type: action.GET_VENDORENTERTAINMENT,
    payload: {},
    vendorId: vendorId,
  };
};

const ACTION_HANDLERS = {
  [action.SET_VENDORENTERTAINMENT]: (state, action) => {
    return { ...state, ...action.payload };
  },
  [action.GET_VENDORENTERTAINMENT]: (state, action) => {
    return { ...state, ...action.payload };
  },
};

let defaultState = {
  entertainment: [],
};

export const reducer = (state = defaultState, action) => {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
};
